import * as React from "react";
function SvgTag(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M26.1 3.6l17.4 14.1L21 45.5l-14.7-.3-2.8-13.8L26.1 3.6M25.7 0L.8 30.7l3.4 16.9 18 .4 24.9-30.7C47.2 17.3 25.7 0 25.7 0zM13.8 33.1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5-2.5-1.1-2.5-2.5c-.1-1.3 1.1-2.5 2.5-2.5m0-2.5c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTag);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
